import React from "react";
import { Modal } from "react-bootstrap";

type ViewMoreModalProps = {
  show?: boolean;
  title?: string;
  content?: React.ReactNode;
  customClassName?: string;
  customClassNameForBody?: string;
  customClassNameForHeader?: string;
  confirmBtnText?: string;
  cancelBtnText?: string;
  modalSize?: string;
  customClassNameForFooter?: string;
  showHeadingLine?: boolean;
  onModalSubmit?: (submit: boolean) => void;
};

const ViewMoreModal: React.FC<ViewMoreModalProps> = ({
  customClassName,
  show = false,
  title = "",
  content = "",
  modalSize = "modal-md",
  customClassNameForBody,
  onModalSubmit
}) => {
  const handleClose = () => {
    onModalSubmit?.(false);
  };
  return (
    <div className={`header-border ${customClassName}`}>
    <Modal
      show={show}
      onHide={
        handleClose
      }
      centered
      className={`${modalSize} custom-modal vewScanLogPadding`}
    >
      <Modal.Header className="thin-scroll"
        closeButton
      >
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      {(title)? <hr className="my-0"></hr>:""}

      <Modal.Body className={`${customClassNameForBody} my-3 fs-15 pt-0 me-1 overflow-auto viewModalHeight text-wrap min-w-fit text-break `}>
       <div className="pb-3">{content}</div> 
      </Modal.Body>


    </Modal>
    </div>
  );
};

export default ViewMoreModal;
